var EnumTokenService;
(function (EnumTokenService) {
    EnumTokenService["ACCESS_TOKEN"] = "access_token";
    EnumTokenService["REFRESH_TOKEN"] = "refresh_token";
})(EnumTokenService || (EnumTokenService = {}));
export { EnumTokenService };
